module.exports = __webpack_public_path__ + "static/media/Home_Icon.9c40d4e7.svg";